export default __webpack_public_path__ + "static/media/kitAlarma2Mobile.43e5d8dc.png";